export type PasswordStrength = 'weak' | 'fair' | 'strong'

export function getPasswordStrength(password: string): PasswordStrength | null {
  if (!password) return null
  const hasNumber = /\d/.test(password)
  const hasSpecial = /[^a-zA-Z0-9]/.test(password)
  const hasUpper = /[A-Z]/.test(password)
  const score = (password.length >= 10 ? 1 : 0) + (hasNumber ? 1 : 0) + (hasSpecial ? 1 : 0) + (hasUpper ? 1 : 0)
  if (password.length < 6) return 'weak'
  if (score >= 3) return 'strong'
  if (score >= 2 || password.length >= 8) return 'fair'
  return 'weak'
}

export function humanizeAuthError(message: string): string {
  const m = message.toLowerCase()

  if (m.includes('user already registered') || m.includes('already been registered') || m.includes('email address is already')) {
    return 'That email is already in use. Already have an account?'
  }
  if (m.includes('invalid login credentials') || m.includes('invalid email or password')) {
    return 'Wrong email or password. Try again or use a sign-in link.'
  }
  if (m.includes('email not confirmed')) {
    return 'Check your email — we sent a confirmation link when you signed up.'
  }
  if (m.includes('too many requests') || m.includes('rate limit')) {
    return 'Too many attempts. Wait a minute and try again.'
  }
  if (m.includes('password should be')) {
    return 'Password must be at least 6 characters.'
  }
  if (m.includes('weak password') || m.includes('password is too weak')) {
    return 'Please choose a stronger password (mix letters, numbers, and symbols).'
  }
  if (m.includes('invalid email')) {
    return 'That doesn\'t look like a valid email address.'
  }
  if (m.includes('network') || m.includes('fetch')) {
    return 'Network error. Check your connection and try again.'
  }

  return message
}
